import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronDownMedium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconChevronDownMedium"><Path d="M19.4141 9.5L12 16.9141L4.58594 9.5L6 8.08594L12 14.0859L18 8.08594L19.4141 9.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronDownMedium;
